import { Component, ContentChild, OnInit, ViewChild, Inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { IonContent, Platform } from '@ionic/angular';
import { debounceTime } from 'rxjs/operators';
import { Navigator } from 'src/app/services/routing/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { BalanceModel } from 'src/app/models/balance-model';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { AddressService } from 'src/app/services/address/address.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';
import { CurrencyFormatterPipe } from 'src/app/pipes/currency-formatter/currency-formatter.pipe';
import { Browser } from '@capacitor/browser';
//import { BankConnectAuth } from 'capacitor-plugin-webauth-session';

@Component({
  selector: 'app-withdrawal-vip-widget',
  templateUrl: './withdrawal-vip-widget.component.html',
  styleUrls: ['./withdrawal-vip-widget.component.scss'],
  providers: [CurrencyFormatterPipe]
})
export class WithdrawalVipPreferredComponent extends WithdrawalBaseComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  public error = null;

  public withdrawalForm: FormGroup;

  public amount: AbstractControl;
  public customerAccountID: AbstractControl;
  public currency_code: AbstractControl;
  public payment_type_code: AbstractControl;

  public accounts: any = [];
  public accountBalances: BalanceModel;
  public isPageLoaded: boolean = false;
  public vendorLogoUrl: string = '';
  public ssnValue: string;
  private paymentType: any = [];
  public newWindow: any;
  vipWithdrawWidgetURL: any;

  public disableWithdrawButton: boolean = false;
  public enterCounts = 0;
  public labels: DepositMainLabels;
  public enterPressed: boolean;
  private isSessionOpen: boolean = false;

  constructor(
    public addressService: AddressService,
    public events: EventsService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
    public withdrawService: WithdrawalService,
    public balanceService: AccountBalanceService,
    public utils: UtilsService,
    public userSessionService: UserSessionService,
    public configService: ConfigService,
    public successMessageService: SuccessMessageService,
    public platform: Platform,
    private iab: InAppBrowser,
    public currencyFormatter: CurrencyFormatterPipe,
    @Inject('IOS_WEB_AUTH_SESSION') private webAuthSession: any
  ) {
    super();

    this.successMessageService.clearMessage();
    this.error = null;
    this.labels = new DepositMainModel();
  }
  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('vippreferred').then((response: DepositMainLabels) => {
      this.labels = response;
    });
  }

  ngOnInit() {
    this.vipWithdrawWidgetURL = this.configService.getConfig().FEATURE_VIP_WITHDRAW_WIDGET_URL;

    this.withdrawalForm = new FormGroup(
      {
        amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
        currency_code: new FormControl(''),
        payment_type_code: new FormControl(''),
      }
    )

    this.amount = this.withdrawalForm.get('amount');

    this.events.subscribe('event:withdrawal', (data) => {
      if (data?.paymentMethod === 'PV') {
        this.closeiAB();
      }
    });

    this.events.subscribe('event:withdrawal:failed', (data) => {
      if (data?.paymentMethod === 'PV') {
        this.closeiAB();
      }
    });
  }

  private closeiAB() {
    const iabCloseTimeout = Number(this.configService.getConfig().FEATURE_VIP_DEPOSIT_IAB_CLOSE_TIMEOUT) || 3000;
    setTimeout(() => {
      if (this.isAndroidApp()) {
        //Not possible to programmatically close capacitor browser on android
      } else if(this.isIosApp() && this.webAuthSession && this.isSessionOpen) {
        this.webAuthSession.cancelSession();
      }
    }, iabCloseTimeout);
  }

  ionViewWillEnter() {
    this.onGetAccounts();
    this.successMessageService.clearMessage();
    this.onGetBalance();
  }

  public radioChangedCard(e) {
    console.log("hello", e.detail.value);
  }

  onGetBalance() {
    this.balanceService.getBalance().subscribe({
      next: (balance: BalanceModel) => {
        if (balance) this.accountBalances = balance;
      },
      error: (error) => this.error = error
    });
  }

  onGetAccounts() {
    this.accounts = [];
    this.cashierService.callListAccounts().subscribe({
      next: (response) => {
        if (response.result) {
          this.accounts = response.payload
            .filter(account => account.paymentTypeCode === "PV")
            .map((account, key) => {
              account.id = key;
              return account;
            });
        }
        this.isPageLoaded = true;
      }
    });
  }

  submit() {
    this.disableWithdrawButton = true;
    this.checkEnterSubmission();
  }

  checkEnterSubmission() {
    if (this.enterPressed === true) {
      if (this.enterCounts == 1) {
        setTimeout(() => { this.onWithdraw() }, 200);
      }
      this.disableWithdrawButton = false;
      this.enterPressed = false;

    } else {
      setTimeout(() => { this.onWithdraw() }, 200);
    }
  }

  isMobileApp() {
    return this.platform.is("capacitor");
  }

  private isAndroidApp() {
    return this.platform.is("capacitor") && this.platform.is("android");
  }

  private isIosApp() {
    return this.platform.is("capacitor") && this.platform.is("ios");
  }

  onWithdraw() {
    this.disableWithdrawButton = true;
    this.successMessageService.clearMessage();
    this.error = null;

    this.withdrawalForm.get("currency_code").setValue(this.cashierService.customer.preferredCurrency.currencyCode);
    this.withdrawalForm.get("payment_type_code").setValue("PV");

    this.withdrawService.callWithdrawV2(this.withdrawalForm.value).pipe(debounceTime(300)).subscribe({
      next: (response: any) => {
        if (response && !!response.result) {

          this.onGetBalance();

          let depositEventData: AffiliateTrackerCallbackParams = {
            customer_id: this.cashierService.customer.customerId,
            amount: this.withdrawalForm.get('amount').value
          }


          if (!isUndefined(response) && !!response.result) {
            // this.paymentRequestID = response.payload.paymentRequestID;
            let sessionId = response.payload.parameters.sessionId;

            if (!this.isMobileApp()) {
              let w: any = window;
              this.newWindow = w.open("about:blank", "_system");
              this.newWindow.document.write(
                "<style> body{ background:var(--ion-color-secondary);!important;  position: relative;} div.container { margin: 0;position: absolute;top: 50%;left: 50%;-ms-transform: translate(-50%, -50%); transform: translate(-50%, -50%);color: white;font-family: roboto;font-size: 1.5em; }</style>"
              );
              this.newWindow.document.write(
                "<body><div class='container'>LOADING...</div></body>"
              );
            }
            this.navigator.dismissAll();
            let vipWidgetUrl = this.vipWithdrawWidgetURL ? this.vipWithdrawWidgetURL + sessionId : undefined;

            if (this.isMobileApp() && vipWidgetUrl) {
              return this.handleMobileView(vipWidgetUrl)
            } else {
              this.newWindow.location = vipWidgetUrl;
              this.disableWithdrawButton = false;


              return this.newWindow.focus();
            }
          }
          setTimeout(() => this.events.publish('event:withdraw', depositEventData), 2000);

          this.successMessageService.setMessage('Your withdrawal request has been received.');

          this.balanceService.updateBalance();

          this.content.scrollToTop();
          this.disableWithdrawButton = false;
          this.error = null;
          this.withdrawalForm.reset();
        }
      },
      error: (error) => {
        this.error = this.handleError(error);
        this.disableWithdrawButton = false;
      }
    });
    setTimeout(() => this.enterCounts = 0, 3000);
    this.error = null;
  }

  private async handleMobileView(vipWidgetUrl) {
    if(this.isAndroidApp()) {  
      await Browser.open({
        url: vipWidgetUrl
      });
    } else if(this.isIosApp()) {
      this.isSessionOpen = true;
      this.webAuthSession.startSession({
        urlString: vipWidgetUrl,
        returnUrlScheme: 'mohegansunnj-play'
      }).then(result => {
        this.isSessionOpen = false;
        console.log("Session completed", result);
      })
      .catch(error => {
        this.isSessionOpen = false;
        console.error("Session failed", error);
      });
    }
    this.disableWithdrawButton = false;
  }

}
